export const colorRocket = () => {
  if (process.env.VUE_APP_PROVIDER == "beemove") {
    return "#fcac00";
  } else {
    return "#9239d3";
  }

  // return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
};
export const namePlatForm = () => {
  if (process.env.VUE_APP_PROVIDER == "beemove") {
    return "Beemove";
  } else {
    return "Rocket 8";
  }
};

export const checkRocket = () => {
  return process.env.VUE_APP_PROVIDER == "beemove";
};

export const classTablePlatform = value => {
  if (process.env.VUE_APP_PROVIDER == "beemove") {
    return "table-platform";
  } else {
    return "";
  }
};

export const classBodyTable = value => {
  if (process.env.VUE_APP_PROVIDER == "beemove") {
    return "body-platform";
  } else {
    return "";
  }
};

export const classTable = (value) => {
  if (process.env.VUE_APP_PROVIDER == 'beemove') {
    return 'table-collapse';
  } else {
    return 'table-separate';
  }
};

export const nameTheme = process.env.VUE_APP_PROVIDER
